import userRoleService from "./userRoles.service";

export const moduleService = (account: any, isLiteApp: boolean, workspacesFetched: boolean = false) => {
  const modules: { 
    id: string; 
    icon: string; 
    to: string, 
    label: string,
    onClick?: (key: string) => void
  }[] = [];

  const addModule = (id: string, icon: string, to: string, label: string, onClick?: (key: string) => void) => {
    modules.push({ id, icon, to, label, onClick });
  };

  const roles = [
    { access: userRoleService.canAccessSearch(), id: 'search', icon: '/images/menu/search.json', to: '/search', label: 'Search'},
    { access: userRoleService.canAccessHub(), id: 'hub', icon: '/images/menu/hub.json', to: '/hub', label: 'Content Hub' },
    { access: userRoleService.canAccessExperiences(workspacesFetched), id: 'experiences', icon: '/images/menu/experiences.json', to: '/experiences', label: 'Experiences' },
    { access: userRoleService.canAccessCollection(), id: 'collections', icon: '/images/menu/collections.json', to: '/collections', label: 'Collections' },
    { access: userRoleService.canAccessConversation(), id: 'conversations', icon: '/images/menu/conversations.json', to: '/conversations', label: 'Conversations' },
    { access: userRoleService.canAccessDealRoom(), id: 'deal-rooms', icon: '/images/menu/deal_room.json', to: '/deal-rooms', label: 'Deal Rooms' },
    { access: isLiteApp ? false : userRoleService.canAccessDealInsights(account), id: 'deal-insights', icon: '/images/menu/deal_insights.json', to: '/deal-insights', label: 'Deal Insights' },
    { access: isLiteApp ? false : userRoleService.canAccessEngage(account), id: 'engage', icon: '/images/menu/engage.json', to: '/engage', label: 'Engage' },
    { access: userRoleService.canAccessCoaching(), id: 'coaching', icon: '/images/menu/hey_sales.json', to: '/coaching', label: 'Hey Sales'},
    { access: userRoleService.canAccessReport(), id: 'reports', icon: '/images/menu/reports.json', to: '/reports', label: 'Reports' },
    { access: userRoleService.canShare(), id: 'compose', icon: '/images/menu/compose.json', to: '', label: 'Compose'}
  ];

  roles.forEach(role => {
    if (role.access) {
      addModule(role.id, role.icon, role.to, role.label);
    }
  });

  return modules;
}
